import { call, all } from 'redux-saga/effects'

import { loginSaga } from './login/loginSaga'
import { userSaga } from './user/userSaga'

import { forgotPasswordSaga } from './forgotPassword/forgotPasswordSaga'
import { dashboardSaga } from './dashboard/dashboardSaga'
import { preferredLanesSaga } from './preferredLane/preferredLanesSaga'
import { locationsSaga } from './locations/locationsSaga'
import { allLoadsSaga } from './loads/allAvaliableSaga'
import { myLoadsSaga } from './loads/myAvaliableSaga'
import { myOffersSaga } from './offers/myOffersSaga'
import { historyOffersSaga } from './offers/historySaga'
import { initSaga } from './initReducer/initSaga'
import { loadDetailsSaga } from './loadDetails/loadDetailsSaga'
import { profileSaga } from './profile/userInformationSaga'
import { assignedOrderSaga } from './orders/assignedSaga'
import { readyOrderSaga } from './orders/readySaga'
import { carrierInformtionSaga } from './profile/carrierInformationSaga'
import { recurringSaga } from './tractors/recurringSaga'
import { myDriverSaga } from './tractors/myDriversSaga'
import { myPaymentSaga } from './payments/paymentSaga'
import { paymentsConnectSaga } from './paymentsConnect/paymentsConnectSaga'
import { faqsSaga } from './faqs/faqsSaga'

export default function * rootSaga () {
  yield all([
    call(loginSaga),
    call(userSaga),
    call(forgotPasswordSaga),
    call(dashboardSaga),
    call(preferredLanesSaga),
    call(locationsSaga),
    call(allLoadsSaga),
    call(myLoadsSaga),
    call(initSaga),
    call(myOffersSaga),
    call(loadDetailsSaga),
    call(profileSaga),
    call(assignedOrderSaga),
    call(readyOrderSaga),
    call(historyOffersSaga),
    call(carrierInformtionSaga),
    call(recurringSaga),
    call(myDriverSaga),
    call(myPaymentSaga),
    call(paymentsConnectSaga),
    call(faqsSaga)
  ])
}
